<template>
    <div>
        <span v-if="props.column.field == 'date'">
            {{ props.row.date }}
        </span>
        <span v-if="props.column.field == 'queue'">
            {{ props.row.queueName }}
        </span>
        <!-- <span v-if="props.column.field == 'type'">
            {{ props.row.type }}
        </span> -->
        <span v-if="props.column.field == 'count'">
            {{ props.row.count }}
        </span>

    </div>
</template>
<script>
export default ({
    name: 'datatable-row-default',
    props: {
        props: Object,
        data: Object,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        combine(mem) {
            if (mem == null) {
                return '-'
            } else {
                mem = mem.map(item => item.replace(":", " ")).join(", ");
                return mem;
            }
        }
    }
})
</script>

<style>
/* .topRule {
    opacity: 0.5;
    cursor: not-allowed;
}

.notTopRule {
    opacity: 1;
    cursor: pointer;
} */
</style>
